var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"app-container"},[_c('global-alerts'),_c('v-flex',{attrs:{"sm12":"","md6":"","offset-md3":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }